import { render, staticRenderFns } from "./SelectGroupItems.vue?vue&type=template&id=683dbab3&"
import script from "./SelectGroupItems.vue?vue&type=script&lang=js&"
export * from "./SelectGroupItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports